import { getOrgSuffix } from './orgSuffix';

/**
 * Transforms a string to snake case. The main difference from _.snakeCase is
 * that it allows for multiple underscores in a row and doesn't trim underscores
 * at the start and end. Those differences are because it's meant to be used as
 * an input mask.
 *
 * Copied from shared-universal/utils/stringUtils, which we couldn't import for
 * ESLint reasons.
 */
function snakeCaseInputMask(input: string): string {
  return input.toLowerCase().replaceAll(/[^a-z0-9_]/g, '_');
}

/**
 * Generate a unique slug, given the orgId (which is used to generate an
 * org-specific suffix) and a list of existing slugs.
 */
export function generateSlug({
  orgId,
  displayName,
  existingSlugsWithoutOrgSuffix,
}: {
  orgId: string;
  displayName: string;
  existingSlugsWithoutOrgSuffix: Array<string>;
}): string {
  const originalSlug = snakeCaseInputMask(displayName);
  const suffix = getOrgSuffix(orgId);

  if (!existingSlugsWithoutOrgSuffix.includes(originalSlug)) {
    return originalSlug + suffix;
  }

  // If this slug is already in use, add a number to make it unique
  let index = 1;
  let slug = originalSlug;
  while (existingSlugsWithoutOrgSuffix.includes(slug)) {
    slug = `${originalSlug}_${index}`;
    index++;
  }

  return slug + suffix;
}
